var React = require('react');

function Asset (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2.000000, 2.000000)","strokeWidth":"3"},[React.createElement("rect",{"x":"0","y":"0","width":"27","height":"27","rx":"2","key":0}),React.createElement("circle",{"cx":"8.5","cy":"8.5","r":"2.5","key":1}),React.createElement("polyline",{"points":"27 17.7272727 19.5 10 3 27","key":2})]));
}

Asset.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 31 31"};

module.exports = Asset;

Asset.default = Asset;
